import passengers from './passengers'
import passengerSSRs from './passengerSSRs'
import uploadedPassengers from './uploadedPassengers'
import passengersToBeDeleted from './passengersToBeDeleted'

export default {
  passengers,
  passengerSSRs,
  uploadedPassengers,
  passengersToBeDeleted,
}
